import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route.ts';

export const accountSettingRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.accountSettings.root,
    lazyImport: () => import('../../domains/protected/account-settings/AccountSettingsRoute.tsx'),
    requiresAuth: true,
    resourceId: 'account-settings',
    children: [
      {
        index: true,
        redirectTo: routesPaths.accountSettings.profile
      },
      {
        path: baseRoutes.accountSettings.profile,
        lazyImport: () =>
          import('../../domains/protected/account-settings/pages/profile/AccountProfileRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.accountSettings.branding,
        lazyImport: () =>
          import('../../domains/protected/account-settings/pages/branding/BrandingRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.accountSettings.settings,
        lazyImport: () =>
          import('../../domains/protected/account-settings/pages/app-settings/AppSettingsRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.accountSettings.emails,
        lazyImport: () =>
          import('../../domains/protected/account-settings/pages/emails/EmailsRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.accountSettings.logs,
        lazyImport: () =>
          import('../../domains/protected/account-settings/pages/audit-logs/LogsRoute.tsx'),
        redirectUnauthorizedTo: routesPaths.iam.root,
        children: [
          {
            index: true,
            lazyImport: () =>
              import('../../domains/protected/account-settings/pages/audit-logs/LogsListRoute.tsx'),
            nav: {
              hideBack: true,
              breadcrumbKey: 'list'
            }
          },
          {
            path: baseRoutes.accountSettings.logDetails,
            lazyImport: () =>
              import('../../domains/protected/account-settings/pages/audit-logs/LogDetailsRoute.tsx'),
            nav: {
              backTo: routesPaths.accountSettings.root,
              breadcrumbKey: 'details'
            }
          }
        ]
      },

      {
        path: '*',
        redirectTo: baseRoutes.accountSettings.root
      }
    ]
  }
];
